import { RootState, SetState } from '@/store/useStore.ts';
import { POPUP_TYPES } from '@/features/Popup/constants';
import { queueAssigner } from '@/utilities/queue/queue.helpers.ts';
import { defaultQueueState, QueueSliceProps } from '@/store/slices/queue/types';

export { defaultQueueState };
export type { QueueSliceProps } from '@/store/slices/queue/types';

const isRealityCheckQueueItem = (type?: string) =>
  type === POPUP_TYPES.REALITY_CHECK;

export const queueSlice = ({ set }: SetState<RootState>): QueueSliceProps => ({
  state: defaultQueueState,
  isPresenting: false,
  presentingType: null,

  addToQueue: (newState) =>
    set(
      (state) => ({
        ...state,
        // @ts-expect-error ignore inferred string enum issue
        state: queueAssigner(state.state || [], newState),
      }),
      false,
      'queue/addToQueue',
    ),

  removeFromQueue: () =>
    set(
      (state) => {
        const typeToRemove = state.presentingType;
        if (typeToRemove) {
          return {
            ...state,
            state: state.state.filter((item) => item?.type !== typeToRemove),
            isPresenting: false,
            presentingType: null,
          };
        }

        const newState = [...(state?.state || [])];
        newState.shift();
        return {
          ...state,
          state: newState,
          isPresenting: false,
          presentingType: null,
        };
      },
      false,
      'queue/removeFromQueue',
    ),

  removeFromQueueSpecific: (payload) =>
    set(
      (state) => {
        const newState = (state?.state || []).filter(
          (item) => item?.type !== payload.type,
        );
        const clearedPresenting =
          state.presentingType === payload.type
            ? { isPresenting: false, presentingType: null }
            : {};

        return {
          ...state,
          state: newState,
          ...clearedPresenting,
        };
      },
      false,
      `queue/removeFromQueueSpecific/${payload.type}`,
    ),

  resetQueueState: () =>
    set(
      () => ({
        state: defaultQueueState,
        isPresenting: false,
        presentingType: null,
      }),
      false,
      'queue/resetQueueState',
    ),

  executeQueue: () =>
    set(
      (state) => {
        if (state.state.length === 0 || state.isPresenting) {
          return state;
        }

        const nextPopup = state.state.find(
          (item) => !isRealityCheckQueueItem(item?.type),
        );
        if (!nextPopup) {
          return state;
        }

        nextPopup.popup();
        return {
          ...state,
          isPresenting: true,
          presentingType: nextPopup.type,
        };
      },
      false,
      'queue/executeQueue',
    ),
});
